<template>
    <p class="smallgrayroundedbox">Sale Ends in <span class="red"><span id="countdownToMidnight"></span></span>
               </p>
</template>


<script>
    export default {
        mounted() {
            setInterval(this.ShowTimes, 1000);
            this.registerDomcontent();
        },
        methods: {
            ShowTimes() {
                var now = new Date();
                var hrs = 23 - now.getHours();
                var mins = 59 - now.getMinutes();
                var secs = 59 - now.getSeconds();
                var str = '';
                str = '<b>' + hrs + ' hrs ' + mins + ' mins ' + secs + ' secs </b>';
                document.getElementById('countdownToMidnight').innerHTML = str;
            },
            registerDomcontent() {
                document.addEventListener("DOMContentLoaded", function (event) {
                     var radioContainer1 = document.getElementsByClassName("radioContainer1");
                     for (let i = 0; i < radioContainer1.length; i++) {
                        let chs = radioContainer1[i].querySelectorAll("input:checked");
                        if (chs.length < 1) {
                           chs = radioContainer1[i].querySelectorAll("input");
                           if (chs.length > 0) {
                              chs[0].checked = true;
                           }
                        }
                     }
                     var oldprice = document.getElementsByClassName("txtOldPrice")[0].textContent;
                     oldprice = oldprice.replace('$', '');
                     var saleprice = document.getElementsByClassName("SalePrice")[0].textContent;
                     saleprice = saleprice.replace('Sale: $', '');
                     var savings = oldprice - saleprice;
                     if (document.getElementById('savings'))
                        document.getElementById('savings').textContent = savings.toFixed(2);

                });
            }
        }
    }
</script>